import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AppConfigurationService {

    public baseApi     : string;
    public campusCode  : string;
    public appVersion  : string;
    public cookieDomain: string;

    constructor() { 

        this.baseApi      = environment.baseApi;
        this.campusCode   = environment.campusCode;
        this.appVersion   = environment.version;
        this.cookieDomain = environment.cookieDomain;

    }

}
